export { documentsManifest, documentsPermissions } from "./documents-manifest";
